<template>
    <div
        data-wow-duration="1.7s"
        :data-wow-delay="planAnimation(plan.type)"
        :class="['item wow fadeInUp', planType(plan.type), { 'active': plan.id === active }]"
        @click="$emit('active')"
    >
        <h4>{{ plan.type }} MEMBERSHIP</h4>
        <div class="price-wrap">
            <div class="price">${{ plan.price.toFixed(2) }}</div>
            <p>Membership Fee (Monthly)</p>
        </div>
        <div class="text-scroll">
            <p>
                <strong>Our {{ plan.type.ucfirst() }} Membership is:</strong>
            </p>
            <p>{{ plan.description }}</p>
        </div>
        <div class="w-100">
            <a class="btn w-100" @click="$emit('select-plan')">select</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MembershipItem",
        props: {
            plan: {
                type: Object,
                required: true
            },
            active: {
                type: Number,
                required: true
            },
        },
        methods: {
            planType(type) {
                return `item-${type}`
            },
            planAnimation() {
                if (this.plan.type === 'platinum') return '0.1s';
                if (this.plan.type === 'golden') return '0.4s';
                if (this.plan.type === 'silver') return '0.7s';
            }
        }
    }
</script>

<style scoped>
    .item {
        cursor: pointer;
    }
    .active {
        border: 2px solid grey;
        box-shadow: 8px 8px 8px 0 rgba(34, 60, 80, 0.2);
        border-radius: 1%;
    }
</style>
